import { createFileRoute } from '@tanstack/react-router';
import { SendTopic } from '../screens/company/topics/SendTopic';

export const Route = createFileRoute('/t/$tenant/settings/developers/send')({
  component: SendTopic,
});
